/**
 * Vehicle equipment / option — référentiel partagé géré par l'admin via
 * `/rental/api/options`. Source : `net.nawam.rental.model.entity.Option`.
 *
 * Rattaché aux véhicules en `@ManyToMany` côté owner-web — l'admin ne fait
 * que maintenir le catalogue.
 */

export type OptionCategory =
  | 'CONFORT'
  | 'SECURITE'
  | 'TECHNOLOGIE'
  | 'EXTERIEUR'
  | 'INTERIEUR'
  | 'AUTRE';

export interface VehicleOption {
  // ── BaseEntity ───────────────────────────────────────────────────────
  id: number;
  createdAt?: string | null;
  updatedAt?: string | null;
  /** BaseEntity boolean flag — active when true. Distinct from `deleted`. */
  status?: boolean;
  deleted?: boolean;
  entityCode?: string | null;

  // ── domain ────────────────────────────────────────────────────────────
  nameFr: string;
  nameEn?: string | null;
  /** URL-safe stable id (ex. `climatisation`, `camera-recul`). Unique. */
  slug: string;
  icon?: string | null;
  category?: OptionCategory | null;
}

/** Body du POST/PATCH `/api/options[/{id}]`. Le back accepte l'entité brute
 *  (pas de DTO dédié) — on envoie juste les champs métier. */
export interface VehicleOptionWriteRequest {
  nameFr: string;
  nameEn?: string | null;
  slug: string;
  icon?: string | null;
  category?: OptionCategory | null;
}

export const OPTION_CATEGORY_LABEL: Record<OptionCategory, string> = {
  CONFORT: 'Confort',
  SECURITE: 'Sécurité',
  TECHNOLOGIE: 'Technologie',
  EXTERIEUR: 'Extérieur',
  INTERIEUR: 'Intérieur',
  AUTRE: 'Autre',
};

/** Ordre d'affichage stable pour les sections groupées. */
export const OPTION_CATEGORY_ORDER: OptionCategory[] = [
  'CONFORT',
  'SECURITE',
  'TECHNOLOGIE',
  'EXTERIEUR',
  'INTERIEUR',
  'AUTRE',
];
